package ru.it_mozaika.sender.js.application.context

import io.ktor.client.call.*
import js.core.jso
import react.*
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http

external interface PropertiesContextInterface{
    var propertiesList: List<Property>
    var updatePropertiesList: () -> Unit
    var hideEmpty: () -> Unit
    var selected: List<Property>
    var selectedIds: List<String>
    var emptyIsHidden: Boolean
    var setSelected: (List<String>) -> Unit
    var currentColumn: TableColumn?
    var setCurrentColumn: (TableColumn?) -> Unit
    var propertyValues: List<String>
    var setPropertiesValues:(List<String>) -> Unit
    var currentRules: Array<Rule>
    var toggleRule: (Pair<String, Rule>) -> Unit
    var deleteRule: (String) -> Unit
    var columnsFilters: List<String>
    var clear: () -> Unit
}

val PropertiesContext = createContext<PropertiesContextInterface>(
    jso {
        propertiesList = listOf()
        updatePropertiesList = {}
        hideEmpty = {}
        selected = listOf()
        selectedIds = listOf()
        emptyIsHidden = false
        setSelected = {}
        currentColumn = null
        propertyValues = listOf()
        setPropertiesValues = {}
        currentRules = arrayOf()
        toggleRule = {}
        columnsFilters = listOf()
        setCurrentColumn = {}
        deleteRule = {}
        clear = {}
    }
)
val PropertiesProvider = FC<PropsWithChildren> { props ->
    val backDrop = useBackdrop()
    val (propertiesList, setPropertiesList) = useState<List<Property>>(listOf())
    val (selected, setSelected) = useState<List<Property>>(listOf())
    val (hide, setHide) = useState(false)
    val storeContext = useContext(StoreContext)
    var currentColumn by useState<TableColumn>()
    var propertiesValues by useState(listOf<String>())
    val (rules, setRules) = useState(mapOf<String, Rule>())

    fun getProperties() {
        backDrop.show()
        Http.get("/subscribers/properties", mapOf("store" to storeContext.currentStoreId.orEmpty())) { response ->
            setPropertiesList(response.body<List<Property>>())
            backDrop.hide()
        }
    }

    useEffect(storeContext.currentStoreId) {
        getProperties()
    }

    PropertiesContext.Provider {
        value = jso {
            setCurrentColumn = {
                currentColumn = it
            }
            setPropertiesValues = {
                propertiesValues = it
            }
            this.currentColumn = currentColumn
            columnsFilters = useMemo(rules.keys){rules.keys.toList()}
            currentRules = useMemo(rules.values) { rules.values.toList().toTypedArray()}
            toggleRule = { newRules ->
                setRules { currentRules ->
                    currentRules.plus(newRules)
                }
            }
            deleteRule = {columnName ->
                setRules{
                    it.minus(columnName)
                }
            }

                this.hideEmpty = {
                setHide {
                    !hide
                }
            }
            this.emptyIsHidden = hide
            this.updatePropertiesList = {
                getProperties()
            }
            this.propertiesList = propertiesList
            this.selected = selected
            this.selectedIds = selected.map { it.id }
            this.setSelected = { ids ->
                setSelected {
                    ids.mapNotNull { id ->
                        propertiesList.find { it.id == id }
                    }
                }
            }
            propertyValues = propertiesValues
            clear = {
                currentColumn = null
                propertiesValues = listOf()
                setRules(mapOf())
            }
        }
        +props.children
    }
}

fun useSubscribersProperties() = useContext(PropertiesContext)